export default __webpack_public_path__ + "static/media/memberlogo-NPA.16d1af0e.gif";